import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { Image } from "@minerva-analytics/pantheon";
import SubscribeForm from "../../components/SubscribeForm";
import SubscribeJump from "../../components/SubscribeJump";
import {
  HeroContainer,
  HomeContainer,
  ImageContainer,
  HomeTitle,
  HomeSubTitle,
  Body,
  Background,
  BackgroundRight,
} from "./Home.styles";
import { HOME_TEXT, HOME_TITLE, HOME_SUBTITLE } from "../../text";
import { CONFIRM, HOME_IMAGE } from "../../image-links";

const Home = () => {
  const status = useSelector(
    (state) => state.subscription.createSubscriberStatus
  );
  const success = status.loaded && !status.failed;
  return (
    <>
      <Helmet>
        <title>Daily Science History Newsletter | The Science Spotlight</title>
        <meta
          name="og:title"
          property="og:title"
          content="Daily Science History Newsletter | The Science Spotlight"
        />
        <meta
          name="og:description"
          property="og:description"
          content="The Science Spotlight is a free email newsletter that helps you explore science history. Sign up here!"
        />
        <meta
          name="description"
          property="description"
          content="The Science Spotlight is a free email newsletter that helps you explore science history. Sign up here!"
        />
      </Helmet>
      <HomeContainer>
        <HeroContainer>
          {success ? (
            <SubscribeJump />
          ) : (
            <>
              <HomeTitle>{HOME_TITLE}</HomeTitle>
              <HomeSubTitle>{HOME_SUBTITLE}</HomeSubTitle>
              <Body>{HOME_TEXT}</Body>
              <SubscribeForm />
            </>
          )}
        </HeroContainer>
        <ImageContainer>
          <Image src={success ? CONFIRM : HOME_IMAGE} />
        </ImageContainer>
        <Background />
        <BackgroundRight />
      </HomeContainer>
    </>
  );
};

export default Home;
